import React, { useState, useEffect } from "react";
import axios from "axios";
import baseUrl from "../../../../BaseURL";

const Earns = ({token}) => {


    const [earning, setEarning] = useState(0);

    useEffect(() => {
        const fetchEarning = async () => {
            try {
                const response = await axios.get(`${baseUrl}/auth/get_acoounts/${token}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setEarning(response.data[0].balance_amount); // Adjust based on API response structure
            } catch (error) {
                console.error("Error fetching earning:", error);
            }
        };

        fetchEarning();
    }, [token]);

    return (
            <h1 className="font-extrabold text-2xl">{earning.toLocaleString()}</h1>
    );
};

export default Earns;